import { NgModule } from '@angular/core';

import { RangeSelectionInputComponent } from './range-selection-input.component';

@NgModule({
  declarations: [RangeSelectionInputComponent],
  exports: [RangeSelectionInputComponent],
})
export class RangeSelectionInputModule {}
export { RangeSelectionInputComponent } from './range-selection-input.component';
